import LoadingSpinner from '@/app/_components/LoadingSpinner/LoadingSpinner'
import EventTickets from '@/app/_components/EventTickets/EventTickets'
import { useEvent } from '@/app/_providers/EventProvider/EventProvider'
import { getEventMeta, hasMeta } from '@/utils/events.utils'
import { useCart } from '@/app/_providers/CartProvider/CartProvider'
import { ReactNode } from 'react'
import TXT from '@/messages'

const TicketsBlock = (): ReactNode => {
  const event = useEvent<Transformed.EventWithTimeslotsAndMeta>()
  const { initialFetchCompleted } = useCart()
  const meta = getEventMeta(event.meta)
  const externalUrl = hasMeta('externalTicketUrl', meta)
    && meta.externalTicketUrl

  if (externalUrl) {
    return null
  }

  if (event.elapsed) {
    return <p>{TXT.elapsedEvent}</p>
  }

  if (!initialFetchCompleted) {
    return <LoadingSpinner />
  }

  return (
    <EventTickets event={event} />
  )

}

export default TicketsBlock
